/// <reference types="./typings/i18n.d.ts" />

export * from "./config";
export * from "./client";
export * from "./types";
export * from "./utils";

export { Trans } from "react-i18next/TransWithoutContext";
